/* eslint-disable max-len */
/* eslint-disable eol-last */
import { createAction, props } from '@ngrx/store';

export const eventCustomPageView = createAction('ANALYTICS_CUSTOM_PAGE_VIEW', props<{ params?: any }>());
export const eventNoAuth = createAction('ANALYTICS_EVENT_NOAUTH', props<{ eventName: string, params?: any }>());

export const eventLogin = createAction('ANALYTICS_LOGIN', props<{ eventName: string, params?: any }>());
export const eventFirstDateLogin = createAction('ANALYTICS_FIRST_DATE_LOGIN', props<{ eventName: string, params?: any }>());

export const eventNewAction = createAction('ANALYTICS_NEW_ACTION', props<{ eventName: string, params?: any }>());

export const eventDevice = createAction('ANALYTICS_DEVICE', props<{ eventName: string, params?: any }>());